<div class="container" *ngIf="!isLoading() && this.activeRecords()?.length">
  <h2>{{'swiper.user.titles' | translate }}</h2>

  <opac-swiper [configuration]="swiperConfig" [gradient]="true">
    <opac-swiper-item *ngFor="let activeRecord of activeRecords(); trackBy: trackByRecordId">
      <opac-card-item
        [title]="activeRecord.title || activeRecord.record.title"
        [author]="activeRecord.author"
        [issueDate]="activeRecord.issueDate"
        [cover]="activeRecord.coverDetails"
        [link]="activeRecord.record | infoUrl"
        [progress]="activeRecord.progress ? { percentage: activeRecord.progress } : undefined"
        [dominantColors]="activeRecord.dominantColors">
        <opac-card-item-social>
          <app-rating
            class="interactions__rating"
            [mean]="activeRecord.meanRating"
            [record]="activeRecord"
            [userRating]="activeRecord.userRating"
            [recordId]="activeRecord.recordId">
          </app-rating>
          <app-favorite-button
            *ngIf="!activeRecord.record.fromBookClub"
            [recordId]="activeRecord.record.id"></app-favorite-button>
          <app-swiper-more-button
            [record]="activeRecord.record"
            [issueDate]="activeRecord.issueDate"
            [rhId]="activeRecord.rssRhId"
            [config]="buttonConfig"
            from="INIT_SCREEN"></app-swiper-more-button>
        </opac-card-item-social>

        <opac-card-item-details>
          <opac-card-item-detail
            *ngIf="activeRecord.checkoutId && activeRecord.timeLeft"
            [label]="'checkouts.left' | translate">
            {{ activeRecord.timeLeft | timeUntil }}
          </opac-card-item-detail>

          <opac-card-item-detail
            *ngIf="!activeRecord.checkoutId && activeRecord.endDate"
            [label]="'checkouts.expires' | translate">
            {{ activeRecord.endDate | date:'mediumDate' }}
          </opac-card-item-detail>
        </opac-card-item-details>

        <div class="buttons-wrapper">
          <ng-container *ngIf="activeRecord.checkoutId">
            <app-download-button [record]="activeRecord.record" from="INIT_SCREEN"> </app-download-button>
          </ng-container>
          <ng-container *ngIf="activeRecord.learningExperienceId">
            <app-external-link-button [record]="activeRecord.record" from="INIT_SCREEN"> </app-external-link-button>
          </ng-container>
        </div>
      </opac-card-item>
    </opac-swiper-item>

    <opac-swiper-item *ngIf="canMakeCheckouts()">
      <active-records-cta (ctaSkeleton)="exploreFullCatalog()"></active-records-cta>
    </opac-swiper-item>
  </opac-swiper>
</div>

<div class="container" *ngIf="isLoading()">
  <opac-skeleton style="display: block; width: 249px; height: 20px; margin-bottom: 8px"></opac-skeleton>
  <opac-swiper [configuration]="swiperConfig">
    <opac-swiper-item *ngFor="let i of [1, 2, 3, 4]">
      <active-records-skeleton></active-records-skeleton>
    </opac-swiper-item>
  </opac-swiper>
</div>
